<dx-box
    #wfDashboardBox
    width="100%"
    height="100%"
    direction="col"
    class="dashboard-container"
    [elementAttr]="{ id: 'wfDashboardBox' + (!widgetId ? '' : widgetId) }"
>
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <!-- When in Portfolio Context -->
            <ng-container *ngIf="!isCommunitySelectorHidden">
                <dx-toolbar *ngIf="filterRowColCount >= 4">
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <app-multi-column-selector
                                #communitySelector
                                [name]="'Community'"
                                [gridSource]="communityList"
                                [boxValue]="communityGridBoxValue"
                                [valueExpr]="'communityId'"
                                [displayExpr]="'communityName'"
                                [columnDef]="communityColumns"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 'auto' }"
                                [showClearButton]="true"
                                [navigateToCommunity]="true"
                                [placeholder]="'Select Community...'"
                                [showHeaderFilters]="true"
                                (gridSelectionEvent)="onCommunitySelection($event)"
                            ></app-multi-column-selector>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-select-box
                                displayExpr="text"
                                [width]="120"
                                [dataSource]="viewOptions"
                                [(value)]="selectedViewOption"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Refresh"
                                hint="Refresh"
                                icon="refresh"
                                (onClick)="refreshDashboard()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>

                <dx-form width="100%" *ngIf="filterRowColCount < 4" [colCount]="filterRowColCount">
                    <dxi-item>
                        <div *dxTemplate class="cc-text-right">
                            <app-multi-column-selector
                                #communitySelector
                                cssClass="widget-drop-down-box"
                                [name]="'Community'"
                                [gridSource]="communityList"
                                [boxValue]="communityGridBoxValue"
                                [valueExpr]="'communityId'"
                                [displayExpr]="'communityName'"
                                [columnDef]="communityColumns"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 'auto' }"
                                [showClearButton]="true"
                                [navigateToCommunity]="true"
                                [placeholder]="'Select Community...'"
                                [showHeaderFilters]="true"
                                (gridSelectionEvent)="onCommunitySelection($event)"
                            ></app-multi-column-selector>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-select-box
                                displayExpr="text"
                                [width]="110"
                                [dataSource]="viewOptions"
                                [(value)]="selectedViewOption"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate [ngClass]="filterRowColCount > 2 ? 'cc-text-right' : 'cc-text-left'">
                            <dx-button
                                type="default"
                                text="Refresh"
                                hint="Refresh"
                                icon="refresh"
                                (onClick)="refreshDashboard()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-form>
            </ng-container>

            <!-- When in Community Context -->
            <ng-container *ngIf="isCommunitySelectorHidden">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-select-box
                                displayExpr="text"
                                [width]="130"
                                [dataSource]="viewOptions"
                                [(value)]="selectedViewOption"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Refresh"
                                hint="Refresh"
                                [icon]="iconRefresh"
                                (onClick)="refreshDashboard()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </ng-container>
        </div>
    </dxi-item>

    <dxi-item [ratio]="1">
        <div *dxTemplate class="chart-container">
            <dx-box #barChartBox width="100%" height="100%" direction="col" (onItemRendered)="onChartContainerReady()">
                <dxi-item [ratio]="1">
                    <dx-chart
                        seriesSelectionMode="single"
                        [adaptiveLayout]="{ keepLabels: false }"
                        [dataSource]="summaryResults"
                        (onPointClick)="chartPointClick($event)"
                        (onLegendClick)="chartLegendClick($event)"
                        (onArgumentAxisClick)="onAxisLabelClick($event)"
                    >
                        <dxo-size [width]="chartWidth" [height]="chartHeight"></dxo-size>
                        <dxo-common-series-settings
                            type="bar"
                            argumentField="status"
                            valueField="itemCount"
                            hoverMode="onlyPoint"
                            selectionMode="onlyPoint"
                            [ignoreEmptyPoints]="true"
                        >
                            <dxo-label [visible]="true" format="largeNumber" position="outside">
                                <dxo-font [size]="14"></dxo-font>
                            </dxo-label>
                        </dxo-common-series-settings>
                        <dxo-argument-axis>
                            <dxo-label [visible]="true" alignment="center">
                                <dxo-font [size]="14"></dxo-font>
                            </dxo-label>
                        </dxo-argument-axis>
                        <dxi-value-axis>
                            <dxo-grid [visible]="true"></dxo-grid>
                            <dxo-label [visible]="true">
                                <dxo-font [size]="14"></dxo-font>
                            </dxo-label>
                        </dxi-value-axis>
                        <dxo-series-template nameField="status"></dxo-series-template>
                        <dxo-legend verticalAlignment="top" horizontalAlignment="right">
                            <dxo-label [visible]="true">
                                <dxo-font [size]="14"></dxo-font>
                            </dxo-label>
                        </dxo-legend>
                        <dxo-export [enabled]="false"></dxo-export>
                        <dxo-tooltip [enabled]="false"></dxo-tooltip>
                        <dxo-argument-axis>
                            <dxo-label [visible]="true" template="labelTemplate"></dxo-label>
                        </dxo-argument-axis>
                        <svg overflow="visible" *dxTemplate="let data of 'labelTemplate'">
                            <text class="axis-template-text" [attr.title]="data.valueText" text-anchor="middle">
                                {{ data.valueText }}
                            </text>
                        </svg>
                    </dx-chart>
                </dxi-item>
            </dx-box>
        </div>
    </dxi-item>
</dx-box>

<dx-load-panel
    [position]="{ of: !widgetId ? 'body' : '#wfDashboardBox' + widgetId }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="!widgetId"
    [shading]="!widgetId"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<dx-popup
    #workflowQueueGridPopup
    [title]="popupTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="detailsVisible"
    (onShown)="repaint($event)"
    (onHidden)="cleanup()"
>
    <div *dxTemplate="let data of 'content'" class="grid-container">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="queue-option-container">
                        <div *ngIf="isLiteModeDefined()" class="dx-field">
                            <div class="dx-field-label">Lite Mode:</div>
                            <div class="dx-field-switch">
                                <dx-switch
                                    [(value)]="isLiteMode"
                                    (onValueChanged)="onLiteModeValueChange()"
                                ></dx-switch>
                            </div>
                        </div>
                    </div>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <app-workflow-queue-datagrid
                        #workflowGrid
                        [storageKey]="'WORKFLOW_DASHBOARD_GRID'"
                        [isLiteMode]="isLiteMode"
                        [dataSource]="selectedSummaryResultItems"
                        (forceRefresh)="onForceRefresh($event)"
                    ></app-workflow-queue-datagrid>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="detailsLoadingVisible"
    [position]="{ of: 'body' }"
    [visible]="detailsLoadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
    [delay]="0"
></dx-load-panel>

<app-lite-mode-preference
    #liteModePreference
    [defaultMode]="true"
    [storageKey]="'WORKFLOW_QUEUE_REPORT'"
    [pageName]="'AAP Workflow Queue'"
    (onLoad)="setStoredLiteMode($event)"
></app-lite-mode-preference>
